export interface Organization {
    apiPath: string;
    id: string;
    name: string;
    version: string;
    dwa_api_key: string;
    enableJunctionAI: boolean;
}